var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDesktop = function SvgIconDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 13 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    fillRule: "evenodd",
    d: "M2.3 1.201h8.4c.331 0 .6.278.6.62v6.2a.61.61 0 0 1-.6.62H2.3a.61.61 0 0 1-.6-.62v-6.2a.61.61 0 0 1 .6-.62m.3.93v5.58h7.8v-5.58z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M4.55 9.571a.46.46 0 0 0-.45.465c0 .257.201.465.45.465h3.9c.248 0 .45-.208.45-.465a.46.46 0 0 0-.45-.465z"
  })));
};
export default SvgIconDesktop;